import React, { useEffect, useState } from 'react';
import { ImageViewer } from 'antd-mobile-v5';
import '../ddsu5168/wiring/index.scss';

export const CompactButtons = ({ ariaLabel, className = '', options, value, onChange }) => (
  <div
    className={`wiring-compact-buttons${className ? ` ${className}` : ''}`}
    role="group"
    aria-label={ariaLabel}
  >
    {options.map((option) => (
      <button
        type="button"
        className={value === option.value ? 'is-active' : ''}
        aria-pressed={value === option.value}
        key={option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export const WiringSelect = ({ ariaLabel, options, value, onChange }) => (
  <label className="wiring-gateway-select">
    <span className="wiring-sr-only">{ariaLabel}</span>
    <select
      aria-label={ariaLabel}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {options.map((option) => (
        <option value={option.value} key={option.value}>{option.label}</option>
      ))}
    </select>
    <span className="wiring-select-arrow" aria-hidden="true">⌄</span>
  </label>
);

const WiringPage = ({ documentTitle, heading, backUrl, filters, diagrams }) => {
  const [previewImage, setPreviewImage] = useState('');

  useEffect(() => {
    document.title = documentTitle;
    window.scrollTo(0, 0);
  }, [documentTitle]);

  return (
    <div className="ddsu5168-wiring-shell">
      <main className="ddsu5168-wiring-page">
        <header className="wiring-toolbar">
          <a className="wiring-back" href={backUrl} aria-label={`返回 ${heading} 产品页`}>
            <span aria-hidden="true">‹</span>
          </a>
          <h1>{heading} 接线图</h1>
        </header>

        {filters && (
          <div className="wiring-filter-bar" aria-label="接线图筛选">
            <div className="wiring-filter-line">{filters}</div>
          </div>
        )}

        <section className="wiring-diagram-list" aria-live="polite">
          {diagrams.map((diagram, index) => (
            <figure
              className={`wiring-diagram${diagram.className ? ` ${diagram.className}` : ''}`}
              key={diagram.id}
            >
              <figcaption className="wiring-diagram-title">
                <span className="wiring-diagram-name">{diagram.title}</span>
                <span className="wiring-diagram-tag">{diagram.tag}</span>
              </figcaption>
              <img
                src={diagram.image}
                alt={diagram.imageAlt}
                loading={index === 0 ? 'eager' : 'lazy'}
                decoding="async"
                onClick={() => setPreviewImage(diagram.image)}
              />
            </figure>
          ))}
        </section>

        <ImageViewer
          image={previewImage}
          visible={Boolean(previewImage)}
          onClose={() => setPreviewImage('')}
        />
      </main>
    </div>
  );
};

export default WiringPage;
